export function stripMarkdownText(text: string): string {
  return (
    text
      // Remove headings (#, ##, etc.)
      .replace(/^\s*#{1,6}\s*/gm, "")
      // Remove bold and italic (**bold**, *italic*, __bold__, _italic_)
      .replace(/(\*\*|__)(.*?)\1/g, "$2")
      .replace(/(\*|_)(.*?)\1/g, "$2")
      // Convert links [text](url) → text
      .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
      // Remove any HTML tags
      .replace(/<\/?[^>]+(>|$)/g, "")
      // Convert all line breaks to space
      .replace(/\n+/g, " ")
      // Collapse multiple spaces
      .replace(/\s+/g, " ")
      .trim()
  )
}
